import React, { useEffect } from 'react';
import { trackSectionView } from '../firebaseConfig';

// Higher-order component for tracking section views
export const withSectionTracking = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  sectionName: string
) => {
  const WithSectionTracking: React.FC<P> = (props) => {
    useEffect(() => {
      trackSectionView(sectionName);
    }, []);

    return <WrappedComponent {...props} />;
  };

  // Set display name for debugging purposes
  WithSectionTracking.displayName = `WithSectionTracking(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithSectionTracking;
};

// Example usage:
// const TrackedComponent = withSectionTracking(YourComponent, 'Section Name'); 